export const GET_DESTINATIONS_BY_PARTNER_PATH = '/graphql/execute.json/yme/getDestinationsByPartnerPath;partnerPath=${partnerPath};destinationRootPath=${destinationRootPath}';
export const PARTNER_PATH_PLACEHOLDER = '${partnerPath}';
export const DESTINATION_ROOT_PATH_PLACEHOLDER = '${destinationRootPath}';
